import {Button, Dialog, DialogContent, Stack, Typography} from '@mui/material';
import {useCallback} from 'react';
import notificationConfig from '../../config/notificationConfig';

const BackNavigationConfirmDialog = (props: {
  setDialog: (val: boolean) => void;
  closeStepper: () => void;
}) => {
  const handleClose = useCallback(() => {
    props.setDialog(false);
  }, [props]);

  return (
    <Dialog
      open
      maxWidth='md'
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'>
      <DialogContent className='px-10  text-center'>
        <Typography
          className='font-bold text-24 mb-2'
          id='alert-dialog-title'
          component='h2'>
          WARNING!!
        </Typography>
        <Typography
          variant='body1'
          id='alert-dialog-description'
          className='mb-1 text-white-50'>
          {`${notificationConfig.backNavigationDialog.dialog}`}
        </Typography>
        <Typography variant='body1' className='text-white-50'>
          {`${notificationConfig.backNavigationDialog.action}`}
        </Typography>
        <Stack
          className='d-flex align-center justify-center pt-5 mt-3'
          direction='row'
          spacing={3}>
          <Button variant='contained' onClick={props.closeStepper}>
            Agree
          </Button>
          <Button variant='outlined' onClick={handleClose}>
            Cancel
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default BackNavigationConfirmDialog;
